module.exports = __webpack_public_path__ + "static/pfb-social-banner.7d7f7438.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Metadata/pfb-social-banner.jpg
// module id = 517
// module chunks = 114276838955818